import React, { useContext, useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Spinner, Alert, Card, Row, Col } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { notifyError } from "../../actions/notifications"
import UserStatistics from "../../components/UserStatistics"
import SwaggerContext from "../../SwaggerContext"
import { createApiCallback, logApiError } from "../../utils/error-handler"

const PatientStats = ({ userId }) => {
  const [patientData, setPatientData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const { userApi, gameSessionApi } = useContext(SwaggerContext)
  const navigate = useNavigate()

  useEffect(() => {
    const loadPatientData = async () => {
      try {
        setLoading(true)

        // Buscar usuario por ID
        userApi.getUserById(userId, createApiCallback(
          (userData) => {
            setPatientData(userData)
            setError("")
          },
          (errorMessage, errorInfo, err, response) => {
            logApiError("Load Patient", err, response)

            if (errorInfo?.statusCode === 404) {
              setError("El paciente no existe")
            } else {
              const msg = errorMessage || "Error al cargar los datos del paciente"
              setError(msg)
              notifyError(msg)
            }

            setPatientData(null)
          }
        ))
      } catch (err) {
        const msg = err instanceof Error ? err.message : "Error desconocido"
        setError(msg)
        setPatientData(null)
      } finally {
        setLoading(false)
      }
    }

    if (userId) {
      loadPatientData()
    }
  }, [userId, userApi])

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "calc(100vh - 200px)" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    )
  }

  if (error || !patientData) {
    return (
      <div>
        <Alert variant="danger" className="mb-3">
          {error || "No se pudieron cargar los datos del paciente"}
        </Alert>
        <Button variant="secondary" onClick={() => navigate("/mis-pacientes")}>
          Volver a Mis Pacientes
        </Button>
      </div>
    )
  }

  return (
    <div>
      <div className="mb-4">
        <Card className="bg-light">
          <Card.Body>
            <Row>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Nombre:</strong> {patientData.name}
                </div>
                <div className="mb-2">
                  <strong>Apellido:</strong> {patientData.surname}
                </div>
                <div className="mb-2">
                  <strong>Usuario:</strong> {patientData.username}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Email:</strong> {patientData.email}
                </div>
                <div className="mb-2">
                  <strong>Validado:</strong>{" "}
                  {patientData.validated ? "✓ Sí" : "✗ No"}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>

      <div className="mb-4">
        <h3 className="mb-3">Estadísticas</h3>
        <UserStatistics
          gameSessionApi={gameSessionApi}
          userId={patientData.id}
        />
      </div>

      <Button variant="secondary" onClick={() => navigate("/mis-pacientes")}>
        Volver a Mis Pacientes
      </Button>
    </div>
  )
}

PatientStats.propTypes = {
  userId: PropTypes.number.isRequired,
}

export default PatientStats
